package com.appsyde.shared.modules.ticket.domain.model

/**
 * Domain value: whether a ticket/thread has history and how many exchanges.
 */
data class HistoryMeta(
    val hasHistory: Boolean,
    val exchangesCount: Int
)
